module.exports = __webpack_public_path__ + "media/state-press-3_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-3_800.jpg
// module id = 47
// module chunks = 0